// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5OSkW","link":"styles_link__qtQKq","logo":"styles_logo__ki+hE","title":"styles_title__CBVF7","open":"styles_open__8s0bD"};